import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import { AnnouncementBanner } from './components/GlobalWidgets';
import LandingPage from './pages/LandingPage';
import AuthCallback from './pages/AuthCallback';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import CharacterCreate from './pages/CharacterCreate';
import GamePage from './pages/GamePage';
import Settings from './pages/Settings';
import AdminFeedback from './pages/AdminFeedback';
import AdminSupport from './pages/AdminSupport';
import './index.css';

function AppRouter() {
  const location = useLocation();
  
  // Dedicated auth callback route — always renders AuthCallback
  if (location.pathname === '/auth/callback') {
    return <AuthCallback />;
  }
  
  // Catch session_id in hash/query on any route (backwards compat from old redirect)
  if (location.hash?.includes('session_id=') || location.search?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/character/create"
        element={
          <ProtectedRoute>
            <CharacterCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/game/:characterId"
        element={
          <ProtectedRoute>
            <GamePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route path="/admin/feedback" element={<AdminFeedback />} />
      <Route path="/admin/support" element={<ProtectedRoute><AdminSupport /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <div className="App">
            <AnnouncementBanner />
            <AppRouter />
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  background: '#0f172a',
                  border: '1px solid rgba(251, 191, 36, 0.3)',
                  color: '#f8fafc',
                },
              }}
            />
          </div>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
